import { convertJSONContentToFormattedText, getNovelActsTree } from '@/utils'
import { useNovelCoreStore } from '@/stores/novelCoreStore'
import { message } from 'antd'
import type { JSONContent } from 'novel'

function downloadText(filename: string, text: string) {
  const blob = new Blob([text], { type: 'text/markdown;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

/** TipTap JSON / 旧字符串 → Markdown 正文（aiGeneration 由 jsonContent 展开） */
function sceneBodyToMarkdown(content: unknown, summary?: string): string {
  if (content && typeof content === 'object') {
    const node = content as JSONContent
    const doc: JSONContent =
      node.type === 'doc' ? node : { type: 'doc', content: [node] }
    const text = convertJSONContentToFormattedText(doc)
    if (text.trim()) return text.trim()
  }
  if (typeof content === 'string' && content.trim()) return content.trim()
  if (typeof summary === 'string' && summary.trim()) return summary.trim()
  return ''
}

/** 从本地 store 拼出论文 Markdown 并下载 */
export function exportThesisMarkdown(novelId?: string): boolean {
  const { novels, novelActs, novelChapters, novelScenes } = useNovelCoreStore.getState()
  const list = novelId ? novels.filter((n) => n.id === novelId) : novels
  if (!list.length) {
    message.info('没有可导出的论文')
    return false
  }

  const parts: string[] = []
  for (const novel of list) {
    parts.push(`# ${novel.attributes.title || '未命名论文'}\n`)
    for (const l of novel.attributes.labels || []) {
      parts.push(`> ${l.label}\n`)
    }
    parts.push('\n')

    const tree = getNovelActsTree(novel.id, novelActs, novelChapters, novelScenes)
    for (const act of tree) {
      parts.push(`## ${act.title || '目录'}\n\n`)
      for (const ch of act.children || []) {
        parts.push(`### ${ch.title || '章'}\n\n`)
        for (const sc of ch.children || []) {
          const attrs = sc.data?.attributes as {
            content?: unknown
            summary?: string
          } | undefined
          const body = sceneBodyToMarkdown(attrs?.content, attrs?.summary)
          if (body) parts.push(`${body}\n\n`)
        }
      }
    }
  }

  const name =
    list.length === 1
      ? `${list[0].attributes.title || 'thesis'}.md`
      : `论文台导出-${new Date().toISOString().slice(0, 10)}.md`
  downloadText(name.replace(/[\\/:*?"<>|]/g, '_'), parts.join(''))
  message.success('已导出 Markdown')
  return true
}
